import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles, Paper, Grid, TextField, LinearProgress, Typography, Input, Select, InputLabel, MenuItem, FormControl, Button, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import API_REST from '../../api-rest-uruk';

const styles = theme => ({
  paper: {
    maxWidth: '50%',
    margin: 'auto',
    marginTop: theme.spacing(6),
    minWidth: '320px',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    fontSize: '1em'
  },
  input: {
    width: '100%'
  },
  formControl: {
    width: '100%',
    marginTop: 16,
    marginBottom: 8
  },
  button: {
    backgroundColor: theme.palette.primary.main
  },
  fab: {
    margin: theme.spacing(2),
    fontSize: 30,
    backgroundColor: 'green'
  },
  hidden: {
    display: 'none'
  },
  submit: {
    justifyContent: 'center',
    marginTop: '10px'
  }
});

const loadApps = (groups) => {
  let apps = [];
  let defaultApp = '';
  let defaultContext = '';
  let defaultRole = '';
  let defaultUserRoleContextId = '';

  groups.forEach((appItem) => {
    const { id: appId, name: appName } = appItem.context.config;
    const { id: contextId, name: contextName } = appItem.context;
    const { id: roleId, name: roleName } = appItem.role;
    const userRoleContextId = appItem.id;
    const selectedApp = appItem.default;
    if (selectedApp) {
      defaultApp = appId;
      defaultContext = contextId;
      defaultRole = roleId;
      defaultUserRoleContextId = userRoleContextId;
    }

    const app = {
      userRoleContextId,
      app: {
        id: appId,
        name: appName
      },
      context: {
        id: contextId,
        name: contextName
      },
      role: {
        id: roleId,
        name: roleName
      }
    };
    apps.push(app);
  });
  const defaultAppContext = defaultUserRoleContextId + '_' + defaultApp + '_' + defaultContext + '_' + defaultRole;
  return { defaultAppContext, apps };
};

const showMenuItems = (apps, classes) => {
  let menuItems = [];
  menuItems.push(<MenuItem key={''} value={''} className={classes.hidden}> {} </MenuItem>);
  apps.map((appObj, index) => {
    const { userRoleContextId, app, context, role } = appObj;
    const fullKey = `${userRoleContextId}_${app.id}_${context.id}_${role.id}`;
    menuItems.push(<MenuItem key={fullKey} value={fullKey}> {`${app.name} - ${context.name} - ${role.name}`} </MenuItem>);
  });
  return menuItems;
};

const Profile = (props) => {
  const [loading, setLoading] = useState(true);
  const { user, classes, t } = props;
  const { username, signInUserSession: { idToken: { payload: { groups, email } } } } = user;
  const phoneNumber = user.signInUserSession.idToken.payload.phone_number;

  const { defaultAppContext, apps } = loadApps(JSON.parse(groups));
  const [app, setApp] = React.useState(defaultAppContext);
  const [disabledSubmit, setDisabledSubmit] = React.useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleChange = (event, setApp) => {
    const selected = event.target.value;
    if (selected) {
      setApp(selected);
      setDisabledSubmit(selected === defaultAppContext);
    }
  };

  const handleSave = async (formData) => {
    setLoading(true);
    const [userRoleContextId, appId] = app.split('_');

    const body = { userRoleContextId };

    API_REST.setDefaultContext(appId, body)
      .then(() => {
        setDisabledSubmit(true);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setDisabledSubmit(true);
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div style={{ padding: 0, position: 'absolute', left: 0, width: '100%', zIndex: 9999 }}>
        <LinearProgress />
      </div>
    );
  }

  return (
  <>
    <Paper className={classes.paper}>
      <form>
        <Grid container>
          <Typography component='h3'>
            {t('profile:title')}
          </Typography>
          <TextField
            id='user'
            label={t('profile:user')}
            defaultValue={username}
            className={classes.input}
            margin='normal'
            inputProps={{
              readOnly: true
            }} />
          <TextField
            id='email'
            label='Email'
            defaultValue={email}
            className={classes.input}
            margin='normal'
            inputProps={{
              readOnly: true
            }} />
          <TextField
            id='phone'
            label={t('profile:phoneNumber')}
            defaultValue={phoneNumber}
            className={classes.input}
            margin='normal'
            inputProps={{
              readOnly: true
            }} />
          <FormControl className={classes.formControl}>
            <InputLabel id='appContext-label'>{`${t('profile:group')} / ${t('profile:context')} / ${t('profile:role')}`}</InputLabel>
            <Select
              labelId='appContext-label'
              id='appContext'
              defaultvalue={app}
              value={app}
              className={classes.input}
              onChange={(e) => (handleChange(e, setApp))}
              input={<Input />}
            >
              {showMenuItems(apps, classes)}
            </Select>
          </FormControl>
        </Grid>
      </form>
    </Paper>
    <Box textAlign='center' className={classes.submit}>
      <Button
        disabled={disabledSubmit}
        size='medium'
        color='primary'
        variant='contained'
        onClick={handleSave}
      >
        {t('profile:save')}
      </Button>
    </Box>
  </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.config.user,
    group: state.config.group
  };
};

Profile.propTypes = {
  classes: PropTypes.object,
  t: PropTypes.func,
  user: PropTypes.object.isRequired

};

export default withTranslation()(withStyles(styles, { withTheme: true })(connect(mapStateToProps, null)(Profile)));
